import { spawn } from "child_process";
import React, { useState, useEffect, useCallback } from "react";
import { render } from "react-dom";
import PostsList from "./PostsList";

// if (!goodsData) {
// 	return;
// }
const { post_type, per_page, site_url, template_uri, orderby, order } =
	goodsData;

const containerID: string = "goods-loader";
// data属性取得
const fields = "author,id,excerpt,title,link,acf,date";

type PostProps = React.ComponentProps<typeof PostsList>["postsdata"];

interface BtnMoreProps {
	onClick?:
		| ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
		| undefined;
}

// FC
const BtnMore: React.FC<BtnMoreProps> = ({ onClick }): JSX.Element => {
	return (
		<button
			className="c-btn is-middle is-primary "
			type="button"
			onClick={onClick}
		>
			SHOW MORE
		</button>
	);
};

const Index: React.FC = (): JSX.Element => {
	if (post_type && fields && site_url && per_page) {
		const [page_num, setPageNum] = useState<number>(1);
		const [error, setError] = useState<any>(null);
		const [isLoaded, setIsLoaded] = useState<boolean>(false);
		const [isAddLoaded, setIsAddLoaded] = useState<boolean>(false);
		const [posts, setPosts] = useState<PostProps>([]);
		const [totalPage, setTotalPage] = useState<number>(0);

		function updatePostsData(): void {
			// REST Api から取得
			const reOrderby = orderby ? `&orderby=${orderby}` : "";
			const reOrder = order ? `&order=${order}` : "";
			const apipath: string = `${site_url}/wp-json/wp/v2/${post_type}?_fields=${fields}&acf_format=standard&page=${page_num}&per_page=${per_page}${reOrderby}${reOrder}`;
			console.log(apipath);
			fetch(apipath)
				.then((res) => {
					setTotalPage(Number(res.headers.get("x-wp-totalpages")));
					return res.json();
				})
				.then(
					(result) => {
						setIsLoaded(true);
						setPosts(posts.concat(result));
						setIsAddLoaded(true);
					},
					(error) => {
						setIsLoaded(true);
						setError(error);
					}
				);
		}

		useEffect(() => {
			updatePostsData();
		}, [page_num]);

		const loadMore = useCallback(() => {
			setIsAddLoaded(false);
			setPageNum((page_num) => page_num + 1);
		}, [page_num, isAddLoaded]);

		if (error) {
			return <div>Error: {error.message}</div>;
		} else {
			if (isLoaded && posts.length) {
				return (
					<div>
						<PostsList
							postsdata={posts}
							template_uri={template_uri}
						/>
						<div className="c-btn-container has-center">
							{!isAddLoaded && <span>Loading...</span>}
							{page_num < totalPage && isAddLoaded && (
								<BtnMore onClick={loadMore} />
							)}
						</div>
					</div>
				);
			} else {
				return <div>Loading...</div>;
			}
		}
	} else {
		return <div>Error</div>;
	}
};

render(<Index />, document.getElementById(containerID));
